import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LoaderService} from './services/loader.service';
import {LogementService} from './services/logement.service';
import {IntroService} from './services/intro.service';
import {AuthService} from "./services/auth.service";
import {environment} from "../environments/environment";
import {ParcourTravauxService} from "./services/parcour-travaux.service";
import {ToastService} from "./services/toast.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {

  isMenuCollapsed = true;
  showMenu = false;

  constructor(
    public loaderService: LoaderService,
    private logementService: LogementService,
    private introService: IntroService,
    private authService: AuthService,
    private parcourTravauxService: ParcourTravauxService,
    private toastService: ToastService,
  ) {
    authService.isAuthenticated().then((connected) => {
      if (connected && null !== localStorage.getItem('projetTravauxIdToStore')) {
        parcourTravauxService.addMyProjetTravaux().then((data) => {
          localStorage.removeItem('projetTravauxIdToStore');
          if ('success' === data.status) {
            this.toastService.show(data.message, {classname: 'toast-success'});
          }
        });
      }
      if (!authService.isParcoursTravauxRoute() && !connected) {
        let pathname = '';
        if (window.location.pathname.replace(/\//g, "") !== "") {
          pathname = window.location.pathname;
        }
        window.location.href = environment.baseUrlBack + 'login?redirect=' + window.location.origin + pathname;
      } else {
        this.showMenu = connected;
        this.hideSplashscreen();
      }

      if (this.showMenu) {
        this.logementService.loadAndSetDefaultLogementCourant();
        this.introService.start();
      }
    });
  }

  toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }

  private hideSplashscreen(): void {
    const appRoot: HTMLElement = document.getElementById('app-root');
    const splashScreen: HTMLElement = document.getElementById('splashscreen');
    if (splashScreen) {
      splashScreen.remove();
    }
    appRoot.style.display = 'block';
  }
}
